import ENTERTAINMENT from './Assets/Projects/entertainment.png';
import FITNESS from './Assets/Projects/fitness.png';
import FLASHTYPE from './Assets/Projects/flashtype.png';
import POKEDEX from './Assets/Projects/pokedex.png';
import AINEWS from './Assets/Projects/AI_news.png';
import NAMEIT from './Assets/Projects/name_it.png';

export const PROJECTS = [
  {
    image: ENTERTAINMENT,
    name: 'Entertainment-Hub',
    technologyUsed: 'React, Material UI, Nodejs, REST APIs',
    description:
      'This is a Movies and TV Series Website where you can find and search the latest movies and series details. In this you can find afunctionality of trending page where you can find the latest trending movies and series according to the ratings.',
    url: 'http://jobinjohnson22.github.io/Movies-Series-Hub/',
  },
  {
    image: FITNESS,
    name: 'Fitness-Website',
    technologyUsed: 'Reactjs, Material UI, Nodejs, REST APIs',
    description:
      "It's a Fitness Website where you can get different modes of exercise for a particular muscle. In this you can get 100+ different exercises.",
    url: 'https://jj-fitness-website.netlify.app/',
  },
  {
    image: FLASHTYPE,
    name: 'FLASHTYPE',
    technologyUsed: 'Reactjs, Nodejs, REST APIs',
    description:
      'It’s a Typing Speed Test Application where we can check the typing speed ( in wpm ) and can share the results with friends too.',
    url: 'http://jobinjohnson22.github.io/flashtype',
  },
  {
    image: POKEDEX,
    name: 'POKEDEX',
    technologyUsed: 'Reactjs, Nodejs, REST APIs',
    description:
      'It’s is a Pokemon finder Application where we can find all the Pokemon details.',
    url: 'http://jobinjohnson22.github.io/PokemonFinder',
  },
  {
    image: AINEWS,
    name: 'AI_News_Website',
    technologyUsed: 'Reactjs, Nodejs, REST APIs, Alan AI',
    description:
      'It’s an AI News Reader Application which helps to find out the latest news with a voice command.',
    url: 'https://ai-news-application-alan.netlify.app',
  },
  {
    image: NAMEIT,
    name: 'Name-It',
    technologyUsed: 'Reactjs, Nodejs, REST APIs',
    description:
      'It’s a Name Suggestion Application which will help anyone to find out the best name for project, venture and startup.',
    url: 'http://jobinjohnson22.github.io/NameFinderProj/',
  },
];

export const SKILLS = [
  { name: 'Python', initialRating: 4.5 },
  { name: 'Java', initialRating: 3 },
  { name: 'JavaScript', initialRating: 4 },
  { name: 'Html', initialRating: 4 },
  { name: 'CSS', initialRating: 4 },
  { name: 'Reactjs', initialRating: 4 },
  { name: 'TypeScript', initialRating: 4 },
  { name: 'Redux', initialRating: 4 },
  { name: 'Nodejs', initialRating: 4 },
  { name: 'Material UI', initialRating: 4 },
  { name: 'Git', initialRating: 4 },
  { name: 'AWS', initialRating: 3 },
  { name: 'Bash', initialRating: 3 },
  { name: 'Unix', initialRating: 3 },
];

export const TOOLS = [
  'Visual Studio Code',
  'Git',
  'Chrome DevTools',
  'Npm (Node Package Manager)',
  'Atom',
  'Sublime Text',
  'Linux',
  'Heroku',
  'Postman',
];
